import { EventEmitter, Injectable, Output, Injector } from "@angular/core";
import { ImageService } from './image.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver-es';
import { TranslateService } from "@ngx-translate/core";
import { JSProxyService } from "./jsproxy.service";
import { UsersService } from "./users.service";
import { Cell, Workbook, Worksheet } from "exceljs";



@Injectable()
export class ExcelService
{
  private imagesMap = {};
  private units = [];
  protected usersService: UsersService;

  constructor(private imageService: ImageService, private translate: TranslateService, private jsProxy: JSProxyService, protected injector: Injector)
  {
    this.jsProxy.registerComponent("ExcelService", this, "");
    this.usersService = injector.get(UsersService);
  }

  static toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(domTable: any): void {

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('export');
    worksheet.properties.defaultColWidth = 20;

    this.imagesMap = {};

    this.ExportElement2Worksheet(domTable, worksheet, workbook, 0);

    setTimeout(function () {
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, ExcelService.toExportFileName("file"));
      });
    }, 2000);
  }
  public exportJSONAsExcelFile(JSON: any): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(JSON);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, ExcelService.toExportFileName("file"));
  }

  @Output() onImported: EventEmitter<any> = new EventEmitter();
  arrayBuffer: any;

  Upload(file) {
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      let data = new Uint8Array(this.arrayBuffer);
      let arr = [];
      for (let i = 0; i < data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      const bstr = arr.join("");
      const workbook = XLSX.read(bstr, {type:"binary"});
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      this.onImported.emit(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
    };
    fileReader.readAsArrayBuffer(file);
  }

  private ExportElement2Worksheet(element: any, ws: Worksheet, wb: Workbook, line: number): number
  {
    if (element.nodeType != 1)
      return line;

    if (window.getComputedStyle(element).display == "none")
      return line;

    if (element.nodeName && element.nodeName.toLowerCase() == "table")
    {
      if (!element.rows.length)
        return line;

      if (element.caption && element.caption.innerText != "")
      {
        let colCount = 0;
        for (let i = 0; i < element.rows[0].cells.length; i++)
            colCount += element.rows[0].cells[i].colSpan || 1;

        line++;
        ws.getCell("A" + line).value = element.caption.innerText;
        ws.mergeCells("A" + line + ":" + String.fromCharCode(65 + colCount - 1) + line);
        this.ElementStyles2Cell(element.caption, ws.getCell("A" + line), null);
      }

      for (let i = 0; i < element.rows.length; i++)
        if (element.rows[i].style.display != "none")
        {
          const row = element.rows[i];
          line++;
          let col = 0;
          for (let j = 0; j < row.cells.length; j++)
            col += this.ExportCell2Worksheet(row.cells[j], ws, wb, ws.getCell(String.fromCharCode(65 + col) + line));
        }
      return line + 1;
    }

    for (let i = 0; i < element.childNodes.length; i++)
      line = this.ExportElement2Worksheet(element.childNodes[i], ws, wb, line);

    return line;
  }

  private SetCellText(element: any, cell: Cell)
  {
    let text = element.innerText;

    if (text.length >= 10 && text[2] == "." && text[5] == ".")
    {
      let date = new Date(text.substr(6, 4), text.substr(3, 2) - 1, text.substr(0, 2), 0, 0, 0);
      cell.numFmt = "dd.mm.yyyy";

      if (text.length >= 16 && text[10] == " ")
      {
        cell.numFmt = "dd.mm.yyyy HH:MM";
        date.setHours(text.substr(11, 2), text.substr(14, 2), 0);
      }
      if (text.length == 19 && text[10] == " ")
      {
        cell.numFmt = "dd.mm.yyyy HH:MM:SS";
        date.setSeconds(text.substr(17, 2));
      }

      cell.value = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      return;
    }

    const arr = text.split(" ");
    if (arr.length > 0 && arr.length % 2 == 0)
    {
      let h = 0;
      let min = 0;
      let sec = 0;
      for (let i = 1; i < arr.length; i += 2)
      {
        if (arr[i] == this.translate.instant("h"))
          h = parseInt(arr[i - 1]);
        if (arr[i] == this.translate.instant("min"))
          min = parseInt(arr[i - 1]);
        if (arr[i] == this.translate.instant("sec"))
          sec = parseInt(arr[i - 1]);
      }
      if (h || min || sec)
      {
        cell.value = h + ":" + ((min < 10) ? "0" : "") + min + ":" + ((sec < 10) ? "0" : "") + sec;
        cell.numFmt = "[H]:MM:SS;@";
        return;
      }
    }

    let units = [];
    for (let i = 0; i < this.units.length; i++)
      units.push(this.units[i]);
    units.push(this.translate.instant("km/h"));
    units.push(this.translate.instant("mi/h"));
    units.push(this.translate.instant("km"));
    units.push(this.translate.instant("mi"));
    units.push(this.translate.instant("lt"));

    for (let i = 0; i < units.length; i++)
      if (text.length > units[i].length + 1 && text.indexOf(" " + units[i]) == text.length - units[i].length - 1)
      {
        let value = text.replace(" " + units[i], "");
        const isFloat = value.indexOf(".") >= 0 || value.indexOf(",") >= 0;
        value = isFloat ? parseFloat(value) : parseInt(value);
        if (!isNaN(value))
        {
          cell.numFmt = isFloat ? "0.00\" " + units[i] + "\"" : "0\" " + units[i] + "\"";
          cell.value = value;
        }
        else
          cell.value = text;
        return;
      }

    if (element.dataset.address)
    {
      let parts = element.dataset.address.split(',');
      if(parts.length == 2)
        cell.value = {
          text: text.length ? text : "-",
          hyperlink: (true) //use yandex by default
                    ? 'https://yandex.ru/maps/?pt=' + parts[1] + "," + parts[0]
                    : 'https://www.google.com/maps/place/' + parts[0] + "," + parts[1]
      };
    }
    else
      cell.value = text;
  }

  private ExportCell2Worksheet(element: any, ws: Worksheet, wb: Workbook, cell: Cell):number
  {
    this.ElementStyles2Cell(element, cell, ws);
    this.SetCellText(element, cell);

    let count = 0;
    for (let e = 0; e < element.childNodes.length; e++)
    {
      const subelem = element.childNodes[e];
      switch (subelem.nodeName)
      {
        case "IMG":
        {
          this.AddImage2Cell(subelem, subelem.src, ws, wb, cell, count++);
          break;
        }
        case "BUTTON":
        {
          this.AddImage2Cell(subelem, null, ws, wb, cell, count++);
          break;
        }
      }
    }
    if (element.colSpan > 1)
    {
      const colSpan = parseInt(element.colSpan);
      ws.mergeCells(cell.$col$row + ":" + String.fromCharCode(65 + parseInt(cell.col) - 1 + colSpan - 1) + cell.row);
      return colSpan;
    }
    return 1;
  }
  private AddImage2Cell(img: any, src: string, ws: Worksheet, wb: Workbook, cell: Cell, pos: number)
  {
    const style = window.getComputedStyle(img);
    let height = parseFloat(style.height.replace("px", ""));
    let width = parseFloat(style.width.replace("px", ""));

    if (!src && style.backgroundImage)
    {
      src = style.backgroundImage.replace("url(\"", "").replace("\")", "");
      height *= 0.75;
      width *= 0.75;
    }

    if (!src || src.toLowerCase().indexOf(".png") < 0)
      return;

    ws.getRow(parseInt(cell.row)).height = Math.max(height, 20);

    if (!this.imagesMap[src])
    {
      this.imagesMap[src] = [];
      this.imageService.convertFileToDataURLviaFileReader(src).subscribe(
        response => {
          const image = wb.addImage({ base64: response.image, extension: "png" });
          for (let i = 0; i < this.imagesMap[src].length; i++)
          {
            const item = this.imagesMap[src][i];
            ws.addImage(image, { tl: { col: parseInt(item.cell.col) - 1 + item.pos / 3, row: parseInt(item.cell.row) - 1 }, ext: { width: item.width, height: item.height } });
          }
        }
      );
    }
    this.imagesMap[src].push({ cell: cell, width: width, height: height, pos: pos });
  }

  private Color2ARGB(color: string): string
  {
    const parts = color.replace(/" "/g, "").replace("(", ",").replace(")", "").split(",");
    if (parts[0] == "rgb")
    {
      let r = parseInt(parts[1]).toString(16); if (r.length == 1) r = "0" + r;
      let g = parseInt(parts[2]).toString(16); if (g.length == 1) g = "0" + g;
      let b = parseInt(parts[3]).toString(16); if (b.length == 1) b = "0" + b;
      return ("ff" + r + g + b).toUpperCase();
    }
    return null;
  }
  private ElementStyles2Cell(element: any, cell: Cell, ws: Worksheet)
  {
    let styles = window.getComputedStyle(element);
    cell.font = { bold: styles.fontWeight > "500", color: { 'argb': this.Color2ARGB(styles.color) || "00000000" } };

    if ((!element.colSpan || element.colSpan == 1) && ws)
    {
      const widthStyle = styles.width;
      if (widthStyle && widthStyle.indexOf("px") > 0)
        ws.columns[parseInt(cell.col) - 1].width = parseFloat(widthStyle.replace("px", "")) / 6.0;
    }

    switch (styles.textAlign.toLowerCase())
    {
      case "center":
        cell.alignment = { vertical: 'middle', horizontal: "center" };
        break;
      case "right":
        cell.alignment = { vertical: 'middle', horizontal: "right" };
        break;
    }
    let bgColor = this.Color2ARGB(styles.backgroundColor);
    if (!bgColor) 
    {
        styles = window.getComputedStyle(element.parentNode);
        bgColor = this.Color2ARGB(styles.backgroundColor);
    }

    if (bgColor && bgColor != "FFFFFFFF" && element.id != "reporttitle")
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor }, bgColor: { argb: bgColor } };
  }

  public SetUnits(trendUnits)
  {
    this.units = [];
    for (let i in trendUnits)
      this.units.push(i);
  }
}
